export default __webpack_public_path__ + "static/media/back.61ab3dff.svg";